import {Component, EventEmitter, Input, Output} from '@angular/core';
import {faArrowLeft, faTimes} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-app-navigation-header',
  templateUrl: './app-navigation-header.component.html',
  styleUrls: ['./app-navigation-header.component.scss']
})
export class AppNavigationHeaderComponent {
  icons = {
    back: faArrowLeft,
    close: faTimes
  }
  @Input() title = ''
  @Input() background = '#fff'
  @Input() color = '#000'
  @Input() backRoute = ''
  @Input() closeRoute = ''
  @Input() rightIcon = faTimes
  @Output() onClick = new EventEmitter()
}
